export default [
  {
    id: 1,
    text: "3 средние пиццы от 999 рублей",
    img: "pizzaStocks",
  },
  {
    id: 2,
    text: "Кэшбек 10% на самовывоз (доставка)",
    img: "cashback",
  },
  {
    id: 3,
    text: "3 средние пиццы от 999 рублей",
    img: "pizzaStocks",
  },
  {
    id: 4,
    text: "Кэшбек 10% на самовывоз (доставка)",
    img: "cashback",
  },
];
